webpackJsonp([9],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	var browser;
	
	__webpack_require__(10);
	
	__webpack_require__(16);
	
	__webpack_require__(8);
	
	__webpack_require__(32);
	
	__webpack_require__(19);
	
	__webpack_require__(44);
	
	__webpack_require__(3);
	
	__webpack_require__(23);
	
	__webpack_require__(82);
	
	__webpack_require__(1);
	
	__webpack_require__(5);
	
	__webpack_require__(7);
	
	__webpack_require__(4);
	
	__webpack_require__(2);
	
	browser = {
	  isIE8: !!navigator.userAgent.match(/MSIE 8.0/),
	  isIE9: !!navigator.userAgent.match(/MSIE 9.0/)
	};
	
	
	/*
	 * 配置轮播图
	 */
	
	(function() {
	  var $ban, $carousel, $carsli, $cont, $nav_li;
	  $carousel = $('#carousel');
	  $carsli = $carousel.find('li');
	  $ban = $('.nav');
	  $nav_li = $ban.find('li');
	  $cont = $('.conts');
	  $nav_li.on('click', function(evt) {
	    var $me, id;
	    evt.preventDefault();
	    $me = $(this);
	    id = $me.data('id');
	    $nav_li.removeClass('active');
	    $ban.find('li:eq(' + id + ')').addClass('active');
	    $carsli.removeClass('active');
	    return $carousel.find('li:eq(' + id + ')').addClass('active');
	  });
	  return $cont.on('click', function(evt) {
	    var $conts, $me;
	    evt.preventDefault();
	    $me = $(this);
	    $conts = $me.parent('li').find('.conts');
	    $conts.removeClass('active');
	    return $me.addClass('active');
	  });
	})();
	
	
	/*
	 * 提交问题form
	 */
	
	(function() {
	  var $context, $form, $name, $tel;
	  $form = $('#form_qs');
	  $context = $form.find('textarea[name="question"]');
	  $name = $form.find('input[name="user_name"]');
	  $tel = $form.find('input[name="mobile"]');
	  $context.focus(function(evt) {
	    var $me;
	    evt.preventDefault();
	    $me = $(this);
	    $me.addClass('active');
	    return $form.find('.tips').addClass('active');
	  });
	  $context.on('keyup', function() {
	    var $me, can, fontLeng, max;
	    $me = $(this);
	    max = $me.attr('maxlength');
	    fontLeng = $me.val().length;
	    can = max - fontLeng;
	    return $form.find('.tips .red').html(can);
	  });
	  $form.validate({
	    showErrors: function(errorMap, errorList) {
	      if (errorList.length === 0) {
	        return false;
	      }
	      if (browser.isIE8) {
	        alert(errorList[0].message);
	      }
	      return sweetAlert({
	        type: 'error',
	        title: errorList[0].message,
	        allowOutsideClick: true,
	        confirmButtonText: '确定',
	        confirmButtonColor: '#2F86F9'
	      });
	    },
	    submitHandler: function(form) {
	      var phoneNumber, userId;
	      if (!browser.isIE8) {
	        phoneNumber = form.elements.mobile.value.trim();
	        userId = "MOBI" + phoneNumber;
	      }
	      $(form).ajaxSubmit({
	        dataType: 'json',
	        error: function() {
	          if (browser.isIE8) {
	            alert('对不起！出错了,请稍后重试！');
	          }
	          return sweetAlert({
	            type: 'error',
	            title: '对不起！出错了,请稍后重试！',
	            allowOutsideClick: true,
	            confirmButtonText: '确定',
	            confirmButtonColor: '#2F86F9'
	          });
	        },
	        success: function(res) {
	          if (res.status === 'success') {
	            sweetAlert({
	              type: 'success',
	              title: res.msg[0].info,
	              allowOutsideClick: true,
	              confirmButtonText: '确定',
	              confirmButtonColor: '#2F86F9',
	              timer: 5000
	            });
	            $context.val('');
	            $name.val('');
	            return $tel.val('');
	          } else {
	            if (browser.isIE8) {
	              alert(res.msg[0].info);
	            }
	            return sweetAlert({
	              type: 'error',
	              title: res.msg[0].info,
	              allowOutsideClick: true,
	              confirmButtonText: '确定',
	              confirmButtonColor: '#2F86F9'
	            });
	          }
	        }
	      });
	      return false;
	    }
	  });
	  $context.rules('add', {
	    required: true,
	    messages: {
	      required: '问题不能为空'
	    }
	  });
	  $name.rules('add', {
	    required: true,
	    messages: {
	      required: '姓名不能为空'
	    }
	  });
	  return $tel.rules('add', {
	    required: true,
	    mobileNum: true,
	    messages: {
	      required: '请输入正确的手机号'
	    }
	  });
	})();


/***/ },

/***/ 44:
3,

/***/ 82:
3

});


/** WEBPACK FOOTER **
 ** event-question.ad2a93bd2d587e218baa.js
 **/